import { render, staticRenderFns } from "./VaultDetails.vue?vue&type=template&id=5842541e&scoped=true&"
import script from "./VaultDetails.vue?vue&type=script&lang=js&"
export * from "./VaultDetails.vue?vue&type=script&lang=js&"
import style0 from "./VaultDetails.vue?vue&type=style&index=0&id=5842541e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842541e",
  null
  
)

export default component.exports